import bootstrap = require("bootstrap");
import { Z } from "./query";

export class AuthorisedDDSBSite {

    get userId() {
        return parseInt(document.body.dataset.uid);
    }
    constructor() {
        console.log(`Initialised authorised DDSB page, user id: ${this.userId}`);

        if (document.body.dataset.prr == 'true') {
            Z.forFirst('#reset-password-modal', modal => {
                bootstrap.Modal.getOrCreateInstance(modal, {
                    focus: true,
                    backdrop: 'static',
                    keyboard: false,
                }).show(modal);
            });
        }

        Z.init('[data-approved-quote-tools-id]', qt => {
            let quoteId = qt.dataset.approvedQuoteToolsId;

            Z.forEachFrom(qt, '[data-tool="requote"]', el => {
                el.addEventListener('click', ev => {
                    Z.confirm({
                        prompt: 'Requote',
                        class: 'warning',
                        text: `Please select ‘Confirm’ to customise your current quote. Your previous quote revision will still be available for download.`,
                        onConfirm(btn) {
                            Z.get(btn, `/auth/quote/requote/${quoteId}`);
                            //alert(`close quote ${quoteId}`);
                        },
                    });
                });
            });

            Z.forEachFrom(qt, '[data-tool="chat"]', el => {
                el.addEventListener('click', ev => {
                    Z.spinUp(el);
                    fetch(`/auth/quote/chat/${quoteId}`)
                        .then(resp => {
                            Z.spinDown();
                            if (resp.ok) {
                                resp.text().then(uri => {
                                    window.open(uri, '_blank');
                                });
                            }
                        });
                });
            });

            Z.forEachFrom(qt, '[data-tool="order"]', el => {
                el.addEventListener('click', ev => {
                    Z.confirm({
                        prompt: 'Order Quote',
                        class: 'warning',
                        text: `By clicking 'Confirm' this quote will be ordered.`,
                        onConfirm(btn) {
                            Z.get(btn, `/auth/quote/order/${quoteId}`);
                            //alert(`close quote ${quoteId}`);
                        },
                    });
                });
            });

            Z.forEachFrom(qt, '[data-tool="close"]', el => {
                el.addEventListener('click', ev => {
                    Z.confirm({
                        prompt: 'Close Quote',
                        class: 'warning',
                        text: `By clicking 'Confirm' this quote will be treated as closed and will not proceed.`,
                        onConfirm(btn) {
                            Z.get(btn, `/auth/quote/close/${quoteId}`);
                            //alert(`close quote ${quoteId}`);
                        },
                    });
                });
            });

        });
    }
}